// src/pages/AdsSupport/SupportTabs.jsx

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = [
    { label: "자주 묻는 질문", path: "/ads/faq" },
    { label: "1:1 문의", path: "/ads/inquiry" },
    { label: "고객센터", path: "/ads/callcenter" },
];

export default function SupportTabs() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname, state } = location || {};

    const storeBusinessNumber = localStorage.getItem("store_business_number");
    const type = state?.type ?? null;

    const activeIndex = TABS.findIndex((t) => t.path === pathname);
    const segmentWidth = 100 / TABS.length; // 3이면 33.333...

    return (
        <div className="relative bg-white">
            {/* 전체 회색 기본 라인 */}
            <div className="absolute left-0 right-0 bottom-0 h-[1px] bg-border-subtle" />

            {/* ✅ 활성 탭 구간(1/3)만 파란색으로 표시 */}
            {activeIndex >= 0 && (
                <div
                    className="absolute bottom-0 h-[2px] bg-border-primary transition-all duration-200"
                    style={{
                        width: `${segmentWidth}%`,
                        left: `${segmentWidth * activeIndex}%`,
                    }}
                />
            )}

            {/* 탭 버튼들 */}
            <div className="flex px-[16px] pt-[12px] pb-[8px]">
                {TABS.map((tab) => {
                    const isActive = pathname === tab.path;

                    return (
                        <button
                            key={tab.path}
                            type="button"
                            onClick={() =>
                                navigate(tab.path, {
                                    state: { storeBusinessNumber, type },
                                })
                            }
                            className="flex-1 flex items-center justify-center"
                        >
                            <span
                                className={
                                    "text-b2 " +
                                    (isActive
                                        ? "text-text-primary font-semibold"
                                        : "text-text-subtler")
                                }
                            >
                                {tab.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
